import React, { useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { DotLoader } from "react-spinners";
import Sidebar from "../Sidebar";
import Header from "../Header/Header";
import CompanyBanner from "./CompanyBanner";
import CompanySidebar from "./CompanySidebar";
import { usePage } from "../../hooks/usePages";

const CompanyLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const { id } = useParams();
  
  // React Query hook pour récupérer la page
  const { 
    data: pageData, 
    isLoading: pageLoading, 
    error: pageError,
    refetch: refetchPage 
  } = usePage(id);

  const page = pageData?.page;

  // Loading state avec design cohérent
  if (pageLoading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="text-center">
          <DotLoader size={60} color="#6076E7" />
          <p className="mt-4 text-gray-600 dark:text-gray-400 text-sm sm:text-base">
            Chargement de la page...
          </p>
        </div>
      </div>
    );
  }

  // Error state avec retry
  if (pageError) {
    return (
      <div className="text-center">
        <h2 className="text-lg sm:text-xl font-semibold text-red-600 mb-4">
          Erreur lors du chargement de la page
        </h2>
        <button onClick={() => refetchPage()}>
          Réessayer
        </button>
      </div>
    );
  }

  return (
    <div className="flex h-[100dvh] overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
        {/* Site header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        <main className="h-full">
          <div className="px-4 sm:px-6 lg:px-8 py-8 w-full h-full max-w-9xl mx-auto">
            {/* Company banner */}
            <CompanyBanner {...page} />

            {page && (
              <div className="bg-white dark:bg-slate-800 shadow-lg rounded-2xl mb-8">
                <div className="flex flex-col md:flex-row md:-mr-px">
                  <CompanySidebar {...page} />
                  
                  {/* Outlet pour les routes enfants */}
                  <Outlet context={{ 
                    page, 
                    setPage: refetchPage, // ✅ Utiliser refetchPage
                    isLoading: pageLoading, // ✅ État automatique
                    setIsLoading: () => {}, // ✅ Plus nécessaire
                    isModalOpen, 
                    setIsModalOpen 
                  }} />
                </div>
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};

export default CompanyLayout;